import { createSlice } from "@reduxjs/toolkit";

const initialState = {
     Calendar : {
       
      },
      
      
  getCalendarLoading: false,
  getCalendarSuccess: false,
  getCalendarError: null,

 
};

const CalendarReducer = createSlice({
  name: "Calendar",
  initialState,
  reducers: {
    // Get All Calendar
    getCalendarRequest: (state) => {
      state.getCalendarLoading = true;
      state.getCalendarSuccess = false;
      state.getCalendarError = null;
    },
    getCalendarSuccess: (state, action) => {
      state.getCalendarLoading = false;
      state.getCalendarSuccess = true;
      state.Calendar = action.payload;
    },
    getCalendarError: (state, action) => {
      state.getCalendarLoading = false;
      state.getCalendarSuccess = false;
      state.getCalendarError = action.payload;
      state.Calendar = {};
    },
    //clear state
    clearState: (state) => {
      state.getCalendarError = null;
      state.getCalendarSuccess = false;
      state.getSingleCertificateError = null;
      state.getSingleCalendaruccess = false;
    },
  },
});
export const CalendarActions = CalendarReducer.actions;

export default CalendarReducer.reducer;
